var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["container-vs-input-number", { disabled: _vm.disabled }] },
    [
      _c("div", { staticClass: "overlay" }),
      _vm._v(" "),
      _c(
        "vs-input-number",
        _vm._g(
          _vm._b(
            {
              attrs: { disabled: _vm.disabled },
              model: {
                value: _vm.input,
                callback: function($$v) {
                  _vm.input = $$v
                },
                expression: "input"
              }
            },
            "vs-input-number",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07f4ec17", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f4ec17","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseVsInputNumber.vue
// module id = null
// module chunks = 